import { application } from "./application";

import AuthHeartController from "./auth_heart_controller";
import ActivitySelectorController from "./activity_selector_controller";
import AddressSelectorController from "./address_selector_controller";
import AgeSelectorController from "./age_selector_controller";
import AutocompleteController from "./autocomplete_controller";
import AutosubmitController from "./autosubmit_controller";
import AutoVerifyController from "./auto_verify_controller";
import PopoverController from "./popover_controller";
import FlashController from "./flash_controller";
import HideController from "./hide_controller";
import ReferralSourceController from "./referral_source_controller";
import ResultsToggleController from "./results_toggle_controller";
import HeroSearchController from "./hero_search_controller";
import MapboxController from "./mapbox_controller";
import ModalController from "./modal_controller";
import MultimapController from "./multimap_controller";
import SearchAutosubmitController from "./search_autosubmit_controller";
import SearchSyncController from "./search_sync_controller";
import SelectController from "./select_controller";
import ToggleController from "./toggle_controller";

application.register("activity-selector", ActivitySelectorController);
application.register("address-selector", AddressSelectorController);
application.register("age-selector", AgeSelectorController);
application.register("auth-heart", AuthHeartController);
application.register("modal", ModalController);
application.register("autocomplete", AutocompleteController);
application.register("autosubmit", AutosubmitController);
application.register("auto-verify", AutoVerifyController);
application.register("popover", PopoverController);
application.register("flash", FlashController);
application.register("hide", HideController);
application.register("referral-source", ReferralSourceController);
application.register("results-toggle", ResultsToggleController);
application.register("hero-search", HeroSearchController);
application.register("mapbox", MapboxController);
application.register("multimap", MultimapController);
application.register("search-autosubmit", SearchAutosubmitController);
application.register("search-sync", SearchSyncController);
application.register("select", SelectController);
application.register("toggle", ToggleController);
